const debtPaymentId = {
	debt_payment: {
		title: "Laporan Pembayaran Hutang",
		table: {
			title: "Data Laporan Pembayaran Hutang",
			columns: {
				date: "Tanggal",
				cust_name: "Nama Pelanggan",
				store: "Toko",
				ref_id: "Ref ID",
				total: "Total",
				status: "Status",
			},
			status: {
				success: "Berhasil",
				failed: "Gagal",
			},
		},
		empty_state: {
			title: "There is no customer debt payment report data yet",
			description: "There is no customer debt payment report data yet",
		},
	},
};
export default debtPaymentId;
